import { requestApi } from 'api/Api';

export const getUserTrainings = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/user_training/get',
    params
  });
};

export const createUserTraining = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/user_training/create',
    params
  });
};

export const updateUserTraining = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/user_training/update',
    params
  });
};
